import React from 'react';
import classNames from 'classnames';

export default function SectionTitle(props) {
  const { title, subtitle, children, className } = props;

  return (
    <div className={classNames('space-y-6', className)}>
      <div>
        <div className="text-2xl font-semibold text-cs-gray-900">
          {title}
        </div>
        <div className="text-base text-cs-gray-500">
          {subtitle}
        </div>
      </div>
      <div>
        {children}
      </div>
    </div>
  );
}
